// extracted by mini-css-extract-plugin
export var menuIcon = "_qd-0";
export var menuIconInline = "_qd-1";